import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import { BaseText, Separator, Icon } from '@components';
import { Course } from '@models/Courses/CourseModel';

const Container = styled(View)({
  flex: 1,
});

const Title = styled(BaseText)({
  color: '$heading800',
  fontWeight: 'semi',
  variant: 'text.xlarge',
});

const ProgressText = styled(BaseText)({
  color: '$text100',
  variant: 'text.xsmall',
});

const ProgressHeaderContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const ProgressBarContainer = styled(View)({
  height: 6,
  bg: '$background20',
  borderRadius: 2,
  overflow: 'hidden',
});

interface IProgressBarFillProps {
  progress: number;
}

const ProgressBarFill = styled(View)(
  (props: IProgressBarFillProps) => ({
    height: '100%',
    bg: '$primary300',
    borderRadius: 2,
    width: `${props.progress}%`,
  }),
);

export interface ICoursePlaylistHeaderProps {
  course: Course;
}

export const CoursePlaylistHeader = observer(
  ({ course }: ICoursePlaylistHeaderProps) => {
    const { t } = useTranslation();
    const videoProgressText = `${course.lessons.watchedVideosCount}/${
      course.lessons.totalVideosCount
    } ${t('tutorial.videosCompleted')}`;

    return (
      <Container>
        <Title>{t('tutorial.courseContent')}</Title>
        <Separator size="$6" />
        <ProgressHeaderContainer>
          <ProgressText>{videoProgressText}</ProgressText>
          <Icon name="goblet" size={16} color="$primary300" />
        </ProgressHeaderContainer>

        <Separator size="$4" />
        <ProgressBarContainer>
          <ProgressBarFill
            progress={course.lessons.progressPercent}
          />
        </ProgressBarContainer>
      </Container>
    );
  },
);
